Object.defineProperty(exports, '__esModule', { value: true });

const SDK_VERSION = '7.119.1';

exports.SDK_VERSION = SDK_VERSION;
//# sourceMappingURL=version.js.map
